/* eslint-disable no-restricted-globals */
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

const TEXTSTYLE_green = {
  style: 'font-white-blue-out',
  stroke: '#2d6128',
  fontSize: 48,
};

const TEXTSTYLE_red = {
  style: 'font-white-blue-out',
  stroke: '#541717',
  fontSize: 32,
};

/**
 * window for explaining bot-optin process
 */
export class Window_howToBotOptIn extends Window {
  constructor(parent, UIDailyChallengeIcon) {
    super(parent);

    this._isProbablyMobile = !OMT.systemInfo.deviceIsDesktop;

    this._UIDailyChallengeIcon = null;
    if (UIDailyChallengeIcon) {
      this._UIDailyChallengeIcon = UIDailyChallengeIcon;
    }

    this.drawImage();
  }

  drawImage() {
    const container = new Phaser.Group(G.game, this);
    const subContainer = new Phaser.Group(G.game, null);
    const banner = G.makeImage(0, 0, 'popup_top', 0.5, null);
    banner.scale.set(0.9, 0.9);
    const bannerText = new G.Text(0, 0, G.txt('Daily Challenge'), TEXTSTYLE_green, 0.5, banner.width * 0.7, banner.height * 0.7, true, 'center');

    const step1Text = new G.Text(0, 0, `1. ${G.txt('Tap the top menu button')}`, TEXTSTYLE_red, 0.5, banner.width * 0.8, 60, true, 'center');
    const step1Image = G.makeImage(0, 0, 'manual_bot_instructions_1', 0.5, null);
    const step1ImageScale = (banner.width * 0.6) / step1Image.width;
    step1Image.scale.set(step1ImageScale, step1ImageScale);
    step1Text.y = banner.height / 2;
    step1Image.y = 10 + step1Text.y + (step1Text.height + step1Image.height) / 2;
    subContainer.addChild(step1Text);
    subContainer.addChild(step1Image);

    const step2Text = new G.Text(0, 0, `2. ${G.txt('Enable Allow Messages')}`, TEXTSTYLE_red, 0.5, banner.width * 0.8, 60, true, 'center');
    const step2Image = G.makeImage(0, 0, 'manual_bot_instructions_2', 0.5, null);
    const step2ImageScale = (banner.width * 0.6) / step2Image.width;
    step2Image.scale.set(step2ImageScale, step2ImageScale);
    step2Text.y = 10 + step1Image.y + (step1Image.height + step2Text.height) / 2;
    step2Image.y = 10 + step2Text.y + (step2Text.height + step2Image.height) / 2;
    subContainer.addChild(step2Text);
    subContainer.addChild(step2Image);

    const step3Text = new G.Text(0, 0, `3. ${G.txt('Please restart the game to try again.')}`, TEXTSTYLE_red, 0.5, banner.width * 0.8, 60, true, 'center');
    const step3Button = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 196,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText(this._isProbablyMobile ? 'Quit' : 'RESTART'),
        textStyle: 'font-white',
      },
      options: {
        clickFunction: {
          onClick: this.onPlayClicked.bind(this),
        },
      },
    });
    subContainer.addChild(step3Text);
    subContainer.addChild(step3Button);
    step3Text.y = 10 + step2Image.y + (step2Image.height + step3Text.height) / 2;
    step3Button.y = 10 + step3Text.y + (step3Text.height + step3Button.height) / 2;

    const gnome = G.makeImage(0, 0, 'gingerbread_man_large', 0.5, null);
    const gnomeScale = (step2Image.height * 0.3) / gnome.height;
    gnome.scale.set(-1 * gnomeScale, gnomeScale);
    gnome.x = step2Image.x + (step2Image.width - gnome.width) / 2;
    gnome.y = step3Text.y - gnome.height * 0.9;
    subContainer.addChild(gnome);

    const bg = new Phaser.Graphics(game);
    bg.beginFill(0xFFFFFF, 0.3);
    bg.drawRoundedRect(0, 0, banner.width * 0.9, subContainer.height + banner.height / 2, 25);
    bg.endFill();
    bg.x = -bg.width / 2;
    bg.y = (banner.height * 0.5) - bg.height / 2;

    banner.y = bg.y;
    bannerText.y = banner.y - banner.height * 0.1;
    subContainer.y = banner.y;

    const closeBtn = new G.Button(0, 0, 'btn_x', this.onCloseClicked, this);
    closeBtn.scale.set(0.7, 0.7);
    closeBtn.x = banner.x + (banner.width / 2);
    closeBtn.y = banner.y - (banner.height / 2) + closeBtn.height;
    closeBtn.angle = 5;

    container.addChild(bg);
    container.addChild(subContainer);
    container.addChild(banner);
    container.addChild(bannerText);
    container.addChild(closeBtn);
  }

  async onPlayClicked() {
    // why was this disabled ? can it be deleted?
    /*
    let canSubscribe = await OMT.bots.canSubscribeToBot();
    if (canSubscribe == OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.ALREADY) {
      let stateChanged = G.saveState.setBotOptIn(true);
      if (stateChanged) DDNA.tracking.collectEvent("botOptionsChanged", {botSubscribtionStatus:1, botSubscriptionChangeGameArea:"Manual"});
    }
    else if (canSubscribe == OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.YES) {
      let stateChanged = G.saveState.setBotOptIn(false);
      if (stateChanged) DDNA.tracking.collectEvent("botOptionsChanged", {botSubscribtionStatus:0, botSubscriptionChangeGameArea:"Manual"});
    }
    else { // canSubscribe == OMT.bots.CAN_SUBSCRIBE_BOT_FEEDBACK.NO user is no longer able to subscribe through the game
      //Nooo :(
    }

    if (this._UIDailyChallengeIcon) { this._UIDailyChallengeIcon._onDailyChallengeIconClick(); }
    this.closeWindow();
    */
    if (this._isProbablyMobile) {
      OMT.platformFunctions.quitGame();
    } else {
      location.reload();
    }
  }

  onCloseClicked() {
    this.closeWindow();
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.howToBotOptIn = Window_howToBotOptIn;
